import React from "react";
import styled from "styled-components";
import { useTip } from "../Tooltip/Tooltip";
import { CHART_COLORS } from "../../../styles/theme";

/**
 * Barre bi-partite (ex. Cadres / Non-cadres).
 * left / right : { label, value (ReactNode), pct, tip?, color? }
 */
const SplitBar = ({ left, right, noMargin = false }) => {
    const tip = useTip();
    return (
        <Wrapper $noMargin={noMargin}>
            <Labels>
                <span>
                    {left.label} <b>{left.value}</b>
                </span>
                <span>
                    {right.label} <b>{right.value}</b>
                </span>
            </Labels>
            <Track>
                <Seg
                    style={{
                        width: `${left.pct}%`,
                        background: left.color || CHART_COLORS.violet,
                    }}
                    {...tip(left.tip)}
                />
                <Seg
                    style={{
                        flex: 1,
                        background: right.color || CHART_COLORS.violetSoft,
                    }}
                    {...tip(right.tip)}
                />
            </Track>
        </Wrapper>
    );
};

export default SplitBar;

const Wrapper = styled.div`
    margin-bottom: ${({ $noMargin }) => ($noMargin ? 0 : "15px")};
    width: 100%;
`;

const Labels = styled.div`
    display: flex;
    justify-content: space-between;
    font-size: 13px;
    margin-bottom: 6px;
    color: var(--prh-muted);
    b {
        font-weight: 600;
        color: var(--prh-ink);
    }
`;

const Track = styled.div`
    display: flex;
    height: 16px;
    border-radius: 5px;
    overflow: hidden;
    background: var(--prh-bg);
`;

const Seg = styled.div`
    transition: width 0.4s;
`;
